import { forwardRef } from 'react'
import ReactQuill from 'react-quill-new'
import cl from 'classnames'

import { config } from './constants'

import 'react-quill-new/dist/quill.snow.css'
import styles from './styles.module.scss'

const TextEditor = forwardRef<ReactQuill, ReactQuill.ReactQuillProps>(
	({ modules = config.modules, formats = config.formats, className, ...props }, ref) => (
		<ReactQuill
			{...props}
			modules={modules}
			formats={formats}
			className={cl(styles.textEditor, className)}
			ref={ref}
			bounds={`[data-text-editor="name"]`}
		/>
	)
)

export default TextEditor
